module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Corbeyrier_(Vaud)-c1cdda71d45244c6cfe7ac31363c54f3.svg";